const prepareTextWithNewline = (str: string) => {
  const textWithNewline = str.replace(/\n/g, '<br>');

  return textWithNewline;
};

export default prepareTextWithNewline;
